import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '蘑菇视频是免费的吗？',
    answer: '是的，蘑菇视频完全免费！您可以免费观看平台上的所有短视频内容。部分高清内容和独家频道可能需要注册账号后观看，但基础观看体验完全不需要付费。',
  },
  {
    question: '如何在蘑菇视频上发布自己的视频？',
    answer: '下载蘑菇视频App并注册账号后，点击底部"+"按钮即可拍摄或上传您的视频。蘑菇视频支持最长5分钟的视频上传，您可以添加滤镜、音乐和特效来丰富您的视频内容。',
  },
  {
    question: '蘑菇视频支持哪些设备？',
    answer: '蘑菇视频支持iOS和Android移动设备，您可以在App Store和各大安卓应用商店下载。同时，蘑菇视频官网也支持在线观看，无需下载即可在电脑浏览器上浏览精彩内容。',
  },
  {
    question: '视频加载很慢怎么办？',
    answer: '如果遇到视频加载缓慢的情况，建议您检查网络连接状态，或尝试切换至WiFi网络。您也可以在设置中调整视频清晰度为标清模式，以获得更流畅的播放体验。',
  },
  {
    question: '如何联系蘑菇视频客服？',
    answer: '您可以通过以下方式联系我们：1) App内"我的-帮助与反馈"提交问题；2) 发送邮件至 support@moguvideo.com；3) 访问蘑菇视频官网"关于我们"页面填写联系表单。我们的客服团队会在24小时内回复您。',
  },
  {
    question: '蘑菇视频有什么特色功能？',
    answer: '蘑菇视频拥有智能推荐算法，根据您的观看偏好精准推荐感兴趣的视频内容。此外还有离线下载、弹幕互动、视频合拍、直播打赏等丰富功能，让您的观看体验更加有趣和个性化。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
              常见问题
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              关于蘑菇视频的常见问题解答
            </p>
          </div>

          <div className="space-y-3">
            {faqData.map((faq, index) => (
              <div
                key={index}
                className="bg-background-100 rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-200/50 transition-colors duration-200 cursor-pointer"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-950 pr-4">
                    {faq.question}
                  </span>
                  <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
                  }`}
                >
                  <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}